import {
  ArrowLeftIcon,
  ArrowUturnLeftIcon,
  BookOpenIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ClockIcon,
  Cog6ToothIcon,
  DocumentTextIcon,
  MagnifyingGlassIcon,
  PlayIcon,
  PlusIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';
import type { ComponentType, CSSProperties, SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function wrap<P extends SVGProps<SVGSVGElement>>(Icon: ComponentType<P>) {
  return function WrappedIcon({ size = 16, style, ...rest }: IconProps) {
    const merged: CSSProperties = { width: size, height: size, ...style };
    return <Icon {...(rest as unknown as P)} style={merged} />;
  };
}

export const Search = wrap(MagnifyingGlassIcon);
export const Plus = wrap(PlusIcon);
export const Book = wrap(BookOpenIcon);
export const FileText = wrap(DocumentTextIcon);
export const Sparkles = wrap(SparklesIcon);
export const Play = wrap(PlayIcon);
export const Settings = wrap(Cog6ToothIcon);
export const Clock = wrap(ClockIcon);
export const ChevronRight = wrap(ChevronRightIcon);
export const ChevronDown = wrap(ChevronDownIcon);
export const ArrowLeft = wrap(ArrowLeftIcon);
export const Undo = wrap(ArrowUturnLeftIcon);
